import moment from 'moment';

export default function dateFromNow(timestamp) {
  return moment(timestamp).fromNow();
}
